import { useNavigate, useParams } from "react-router-dom";
import { useConfig } from "../containers/ConfigContext";
import { Box, Grid, Paper, Stack } from "@mui/material";
import { ChartTypeEnum } from "../models/company.model";
import CustomizedDoughnut from "../components/Charts/CustomizedDoughnut";
import CustomizedBar from "../components/Charts/CustomizedBar";
import CustomizedLine from "../components/Charts/CustomizedLine";
import CustomizedMixed from "../components/Charts/CustomizedMixed";
import CustomizedTable from "../components/Charts/CustomizedTable";
import LoadingButton from "../components/LoadingButton";
import { getUrlParam } from "../lib/helper";

export default function ChartsPage() {
  const { url } = useParams();
  const { loggedUser } = useConfig();
  const page = loggedUser?.chartConfig?.pages?.find((p) => p.url === url);
  const spacing = 4;
  const { data } = useConfig();
  const navigate = useNavigate();
  const mobile = getUrlParam("mobile");
  return (
    <div>
      {page && (
        <Grid container spacing={spacing}>
          {!mobile && (
            <Grid item xs={12}>
              <Stack direction="row" justifyContent="flex-end" paddingRight={6}>
                <LoadingButton
                  onClick={() => {
                    navigate(`/charts/print/${url}`);
                  }}
                >
                  Export PDF
                </LoadingButton>
              </Stack>
            </Grid>
          )}
          {page.charts.map((chart, i) => (
            <Grid item key={`${chart.type}-${i}`} xs={12} md={chart.width}>
              <Box height={"100%"}>
                {chart.type === ChartTypeEnum.Doughnut && <CustomizedDoughnut chart={chart} reports={data} />}
                {chart.type === ChartTypeEnum.Bar && <CustomizedBar chart={chart} reports={data} />}
                {chart.type === ChartTypeEnum.Line && <CustomizedLine chart={chart} reports={data} />}
                {chart.type === ChartTypeEnum.Mixed && <CustomizedMixed chart={chart} reports={data} />}
                {chart.type === ChartTypeEnum.Table && <CustomizedTable chart={chart} reports={data} />}
              </Box>
            </Grid>
          ))}
        </Grid>
      )}
    </div>
  );
}
